import Navbar from "./Navbar";
import topBannerWeb from "../assets/images/top-banner-web.jpg";
import topBannerMob from "../assets/images/top-banner-mob.png";
import fmLogo from "../assets/images/fm-logo-one.png";
import wave from "../assets/icons/wave.svg";
import youtubeIcon from "../assets/icons/youtube.png";
import instaIcon from "../assets/icons/insta.png";
import fbicon from "../assets/icons/fb.png";
import xIcon from "../assets/icons/x.png";

export default function TopBanner() {
  return (
    <section className="relative w-full h-[75vh]">
      <div className="absolute inset-0 z-0">
        <picture>
          <source media="(max-width: 767px)" srcSet={topBannerMob} />
          <img
            src={topBannerWeb}
            alt="background"
            className="w-full h-full object-cover"
          />
        </picture>
      </div>
      <div className="relative z-50">
        <Navbar />
      </div>

      <div className="absolute top-10 left-4 lg:left-56 z-20">
        <img src={fmLogo} alt="logo" className="w-20" />
      </div>
      <div className="absolute top-48 left-4 flex flex-col gap-1">
        <a
          href="https://www.facebook.com/clubfmkerala/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={fbicon} alt="fb" className="w-8 h-8 mt-0.5" />
        </a>
        <a
          href="https://x.com/clubfmkerala"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={xIcon} alt="x" className="w-8 h-8 mt-0.5" />
        </a>
        <a
          href="https://www.instagram.com/clubfmkerala"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={instaIcon} alt="insta" className="w-8 h-8 mt-0.5" />
        </a>
        <a
          href="https://www.youtube.com/clubfmkerala"
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center cursor-pointer focus:outline-none bg-dark-gray p-1"
        >
          <img src={youtubeIcon} alt="youtube" className="w-8 h-8 mt-0.5" />
        </a>
      </div>

      <div className="absolute bottom-0 translate-y-[calc(50%+4px)] md:translate-y-[calc(50%+8px)] left-0 w-full z-30 flex justify-center pointer-events-none">
        <img src={wave} alt="wave" className="w-full max-w-5xl" />
      </div>
    </section>
  );
}
